import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../firebase-config";

// Route guard for signed-in pages. This is UX only — the real boundary is
// Firestore rules and the auth checks in Cloud Functions.
// useAuth() is undefined until Firebase restores the persisted session,
// then a User or null.
function RequireAuth({ children }) {
  const user = useAuth();
  const location = useLocation();

  if (user === undefined) return null;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export default RequireAuth;
